import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import MOCData from 'apps/pathways/test_data/moc/data';
import TagInput from 'library/components/tag-input';
import CloneableInputGroup from 'library/components/cloneable-input-group';
import { InputEvent as SyntheticEvent } from 'library/helpers/synthetic-events';
import Toggle from 'library/components/form-elements/toggle';
import Tag from 'library/components/tag';

const MOC = {
    "Air Force": "AFSC Codes",
    "Army": "MOS Codes",
    "Marine Corps": "MOS Codes",
    "Navy": "Ratings",
    "Coast Guard": "Ratings"
}
const MilitaryFields = ({ className='', data, onChange, baseKey = '', index, active=false }) => {
    const Years = [...Array(100).keys()].map(n=><option key={2017 - n} value={2017 - n}>{2017 - n}</option>);

    const remove = () => {
        onChange(new SyntheticEvent({
            name: baseKey,
            value: undefined,
            type: 'object'
        }));
    }

    const branch = resolve(data, 'branch', '', '.');

    return (
    <div className={className}>
        <label>
            Military Branch
            <select onChange={onChange} value={branch} disabled={!active} name={`${baseKey}.branch`} required={active}>
                <option value=""> -- Select One -- </option>
                <option value="Army">Army</option>
                <option value="Navy">Navy</option>
                <option value="Air Force">Air Force</option>
                <option value="Marine Corps">Marines</option>
                <option value="Coast Guard">Coast Guard</option>
            </select>
        </label>
        <label disabled={branch === ''}>
            {MOC[branch] || 'Military Occupation Codes'}
            <TagInput data={MOCData} disabled={branch} name={`${baseKey}.code`} value={resolve(data, 'code', '', '.')} disabled={!active || branch === ''} onChange={onChange} required={active} />
        </label>
        <div className="resume-builder-fields-controls">
            <span className="a" onClick={() => remove()}>remove</span>
        </div>
    </div>
    )
}

const Military = ({ data, handleChange }) => {
    const hasMilitary = resolve(data, 'has_military_histories', false, '.');

    const onChange = () => {
        handleChange(new SyntheticEvent({
            name: 'has_military_histories',
            value: !hasMilitary
        }));
    }

    const fieldsClass = [
        "resume-builder-fields",
        !hasMilitary ? 'resume-builder-fields-disabled' : null
    ].filter(c=>c).join(' ')

    return (
        <section className={!hasMilitary ? 'resume-builder-multi-disabled' : ''}>
            <h1><Toggle name="military_histories" checked={hasMilitary} onChange={onChange} /> Military Experience <Tag className="tag-auxilary-3">Optional for Resume Creation</Tag></h1>
            <p>
              If you’ve served in the military, enter your MOS/MOC code so we can map the skills you developed in those jobs and add them to your profile. 
            </p>
            <CloneableInputGroup disabled={!hasMilitary} onChange={handleChange} values={data} dataKey="military_histories" className="resume-builder-multi">
                <MilitaryFields className={fieldsClass} active={hasMilitary} onChange={handleChange} />
            </CloneableInputGroup>
        </section>
    )
}


export default Military;
